import {
  Link,
  Paper,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { formatNumber } from "../../../../../../infrastructure/utils/formatters";
import { ManagementWidgetShell } from "../managementDashboardWidgets";
import { buildDrillDownHref, pick } from "../managementDashboardUtils";

const DIMENSION_TABS = [
  { id: "Province", label: "استان" },
  { id: "Contractor", label: "پیمانکار" },
  { id: "LendingPartner", label: "لندتک" },
];

const deltaColor = (value) => {
  if (value == null) return "text.secondary";
  if (value > 0) return "success.main";
  if (value < 0) return "error.main";
  return "text.primary";
};

const BenchmarkComparisonSection = ({
  loading,
  error,
  data,
  dimensionType,
  onDimensionChange,
  onRetry,
}) => {
  const tab = DIMENSION_TABS.findIndex((t) => t.id === dimensionType);
  const rows = data?.rows || data?.Rows || [];

  return (
    <ManagementWidgetShell
      title="مقایسه بنچمارک"
      subheader="عملکرد هر بعد در برابر میانگین سبد"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      <Tabs
        value={tab >= 0 ? tab : 0}
        onChange={(_e, idx) => onDimensionChange?.(DIMENSION_TABS[idx].id)}
        sx={{ mb: 1.5, minHeight: 40 }}
      >
        {DIMENSION_TABS.map((t, idx) => (
          <Tab key={t.id} label={t.label} value={idx} sx={{ minHeight: 40, fontSize: 13 }} />
        ))}
      </Tabs>

      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1 }}>
        بنچمارک تبدیل: {formatNumber(pick(data, "benchmarkConversionRate", "BenchmarkConversionRate"), 1)}٪
        {" · "}
        SLA: {formatNumber(pick(data, "benchmarkSlaCompliancePercent", "BenchmarkSlaCompliancePercent"), 1)}٪
        {" · "}
        تأخیر: {formatNumber(pick(data, "benchmarkAverageDelayDays", "BenchmarkAverageDelayDays"), 1)} روز
      </Typography>

      {!rows.length && !loading && !error ? (
        <Typography color="text.secondary">داده بنچمارک برای این بعد موجود نیست.</Typography>
      ) : (
        <TableContainer component={Paper} variant="outlined" sx={{ overflowX: "auto" }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>عنوان</TableCell>
                <TableCell align="right">درخواست</TableCell>
                <TableCell align="right">تبدیل</TableCell>
                <TableCell align="right">Δ تبدیل</TableCell>
                <TableCell align="right">SLA</TableCell>
                <TableCell align="right">Δ SLA</TableCell>
                <TableCell align="right">تأخیر</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => {
                const code = pick(row, "dimensionCode", "DimensionCode");
                const href = buildDrillDownHref(pick(row, "drillDown", "DrillDown"));
                return (
                  <TableRow key={code} hover>
                    <TableCell>
                      {href ? (
                        <Link component={RouterLink} to={href} underline="hover">
                          {pick(row, "dimensionTitle", "DimensionTitle")}
                        </Link>
                      ) : (
                        pick(row, "dimensionTitle", "DimensionTitle")
                      )}
                    </TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "requestCount", "RequestCount"))}</TableCell>
                    <TableCell align="right">
                      {pick(row, "conversionRate", "ConversionRate") != null
                        ? `${formatNumber(pick(row, "conversionRate", "ConversionRate"), 1)}٪`
                        : "—"}
                    </TableCell>
                    <TableCell align="right" sx={{ color: deltaColor(pick(row, "conversionDeltaVsBenchmark", "ConversionDeltaVsBenchmark")) }}>
                      {formatNumber(pick(row, "conversionDeltaVsBenchmark", "ConversionDeltaVsBenchmark"), 1)}
                    </TableCell>
                    <TableCell align="right">
                      {pick(row, "slaCompliancePercent", "SlaCompliancePercent") != null
                        ? `${formatNumber(pick(row, "slaCompliancePercent", "SlaCompliancePercent"), 1)}٪`
                        : "—"}
                    </TableCell>
                    <TableCell align="right" sx={{ color: deltaColor(pick(row, "slaComplianceDeltaVsBenchmark", "SlaComplianceDeltaVsBenchmark")) }}>
                      {formatNumber(pick(row, "slaComplianceDeltaVsBenchmark", "SlaComplianceDeltaVsBenchmark"), 1)}
                    </TableCell>
                    <TableCell align="right">
                      {formatNumber(pick(row, "averageDelayDays", "AverageDelayDays"), 1)}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </ManagementWidgetShell>
  );
};

export default BenchmarkComparisonSection;
